module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/colored-buttons/colored-buttons.component.scss
// module id = ./src/app/features/buttons/colored-buttons/colored-buttons.component.scss
// module chunks = main